import { NotifyHelper } from "../../../helpers/toast";
import { eHeSoLopTuNguyenActionsObj } from "../../action-types/thiet-lap/IHeSoLopTuNguyenActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";
export const heSoLopTuNguyenActions = {
  ...generateActions(eHeSoLopTuNguyenActionsObj, "HE_SO_LOP_TU_NGUYEN"),
  ...generateActionForKey(
    eHeSoLopTuNguyenActionsObj,
    "HE_SO_LOP_TU_NGUYEN",
    "SAVE_HESO_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eHeSoLopTuNguyenActionsObj,
    "HE_SO_LOP_TU_NGUYEN",
    "SAVE_HESO_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHeSoLopTuNguyenActionsObj,
    "HE_SO_LOP_TU_NGUYEN",
    "SYNC_SUCCESS",
    () => {
      NotifyHelper.Success("Đồng bộ thành công");
    }
  ),
  ...generateActionForKey(
    eHeSoLopTuNguyenActionsObj,
    "HE_SO_LOP_TU_NGUYEN",
    "SYNC_ERR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHeSoLopTuNguyenActionsObj,
    "HE_SO_LOP_TU_NGUYEN",
    "SAVE_HESO_LOP_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eHeSoLopTuNguyenActionsObj,
    "HE_SO_LOP_TU_NGUYEN",
    "SAVE_HESO_LOP_ERR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
